export const GENERIC_GRID_VIEW_LOAD = 'GENERIC_GRID_VIEW_LOAD';
export const GENERIC_GRID_VIEW_SET_DATA_TYPE = 'GENERIC_GRID_VIEW_SET_DATA_TYPE';
export const GENERIC_GRID_VIEW_SET_NOT_LOGGED_ON = 'GENERIC_GRID_VIEW_SET_NOT_LOGGED_ON';
export const GENERIC_GRID_VIEW_ALL_ROWS = 'GENERIC_GRID_VIEW_ALL_ROWS';
export const GENERIC_GRID_VIEW_SET_SEARCH_PENDING_STATUS = 'GENERIC_GRID_VIEW_SET_SEARCH_PENDING_STATUS';
export const GENERIC_GRID_VIEW_UPDATE_CART_TABS = 'GENERIC_GRID_VIEW_UPDATE_CART_TABS';
export const GENERIC_GRID_VIEW_GET_HEADER_INFORMATION_DATA = 'GENERIC_GRID_VIEW_GET_HEADER_INFORMATION_DATA';
export const GENERIC_GRID_VIEW_RECEIVE = 'GENERIC_GRID_VIEW_RECEIVE';
export const GENERIC_GRID_VIEW_LOAD_ERROR = 'GENERIC_GRID_VIEW_LOAD_ERROR';
export const GENERIC_GRID_VIEW_SHOWEDITIMAGES = 'GENERIC_GRID_VIEW_SHOWEDITIMAGES';
export const GENERIC_GRID_VIEW_IMAGES_WILLBEADDED = 'GENERIC_GRID_VIEW_IMAGES_WILLBEADDED';

export const DROPZONE_SUBMIT_ERROR = 'DROPZONE_SUBMIT_ERROR';
export const ORDER_SCANNING_RECEIVE = 'ORDER_SCANNING_RECEIVE';

export const FIELD_CONFIGURATOR_RECEIVE = 'FIELD_CONFIGURATOR_RECEIVE';
export const FIELD_CONFIGURATOR_ERROR = 'FIELD_CONFIGURATOR_ERROR';
export const FIELD_CONFIGURATOR_UPDATE_SELECTED_FIELDS = 'FIELD_CONFIGURATOR_UPDATE_SELECTED_FIELDS';

export const GENERIC_GRID_FORM_SUBMITBUTTON = 'GENERIC_GRID_FORM_SUBMITBUTTON';
export const GENERIC_GRID_FORM_LOADING = 'GENERIC_GRID_FORM_LOADING';
export const GENERIC_GRID_FORM_RECEIVE = 'GENERIC_GRID_FORM_RECEIVE';
export const GENERIC_GRID_FORM_ERROR = 'GENERIC_GRID_FORM_ERROR';

export const GENERIC_GRID_ROW_UPDATE = 'GENERIC_GRID_ROW_UPDATE';
export const GENERIC_GRID_ROW_ERROR = 'GENERIC_GRID_ROW_ERROR';
export const GENERIC_GRID_ROW_RECEIVE = 'GENERIC_GRID_ROW_RECEIVE';

export const GENERIC_GRID_FIELD_LOAD = 'GENERIC_GRID_FIELD_LOAD';
export const GENERIC_GRID_FIELD_LOAD_ERROR = 'GENERIC_GRID_FIELD_LOAD_ERROR';
export const GENERIC_GRID_FIELD_RECEIVE = 'GENERIC_GRID_FIELD_RECEIVE';
export const GENERIC_GRID_FIELD_LIST_RECEIVE = 'GENERIC_GRID_FIELD_LIST_RECEIVE';
export const GENERIC_GRID_FIELD_ROW_UPDATE = 'GENERIC_GRID_FIELD_ROW_UPDATE';
export const GENERIC_GRID_FIELD_GET_DATA_LIST = 'GENERIC_GRID_FIELD_GET_DATA_LIST';
export const GENERIC_GRID_FIELD_GET_ORGANIZATION_LIST = 'GENERIC_GRID_FIELD_GET_ORGANIZATION_LIST';
export const GENERIC_GRID_UPDATE_FIELDS = 'GENERIC_GRID_UPDATE_FIELDS';

export const GENERIC_GRID_FIELD_SET_ARTICLES_LIST = 'GENERIC_GRID_FIELD_SET_ARTICLES_LIST';
export const GENERIC_GRID_FIELD_SET_EXISTING_ARTICLES_LIST = 'GENERIC_GRID_FIELD_SET_EXISTING_ARTICLES_LIST';
export const GENERIC_GRID_FIELD_RESET_STATE = 'GENERIC_GRID_FIELD_RESET_STATE';

export const CART_RECEIVE = 'CART_RECEIVE';

export const GENERIC_SEARCH_QUERY = 'GENERIC_SEARCH_QUERY';
export const GENERIC_SEARCH_RECEIVE = 'GENERIC_SEARCH_RECEIVE';
export const GENERIC_SEARCH_ERROR = 'GENERIC_SEARCH_ERROR';
export const GENERIC_SEARCH_SHOW_FULL_FORM = 'GENERIC_SEARCH_SHOW_FULL_FORM';
export const GENERIC_SEARCH_SELECT_ITEM = 'GENERIC_SEARCH_SELECT_ITEM';
export const GENERIC_SEARCH_TOGGLE_SHOW_RESULT = 'GENERIC_SEARCH_TOGGLE_SHOW_RESULT';
export const GENERIC_SEARCH_QUERY_GRIDTYPE = 'GENERIC_SEARCH_QUERY_GRIDTYPE';
export const GENERIC_SEARCH_RESET_STATE = 'GENERIC_SEARCH_RESET_STATE';
export const SET_BUTTON_INPROGRESS = 'SET_BUTTON_INPROGRESS';